import { Reveal } from "@/components/Reveal";

const FOUR = [
  ["Budget", "The target, imported once a year from the market templates"],
  ["Booked", "Confirmed revenue from the nightly WideOrbit sync, cash only"],
  ["Pending", "Open deals, spread by month; Proposal counts 40%, Negotiation 70%"],
  ["Projected", "Booked + weighted pending, compared against budget"],
];

export default function Summary() {
  return (
    <section id="overview" className="mx-auto max-w-6xl px-4 sm:px-6 mt-10 scroll-mt-16" data-testid="section-summary">
      <Reveal>
        <p className="font-mono text-[11.5px] uppercase tracking-[0.08em] text-fog">Overview</p>
        <h2 className="mt-2 font-display text-2xl sm:text-3xl text-coal">
          We're aligned with the scope, with one addition
        </h2>
      </Reveal>

      <div className="mt-5 grid lg:grid-cols-2 gap-4">
        <Reveal delay={0.05}>
          <div className="bg-white border border-hair rounded-md p-5 space-y-4 text-[15px] leading-relaxed text-coal/90" data-testid="summary-panel">
            <p>
              My team has been through everything you sent &mdash; the brief, the change
              order, both 2027 templates and the current budget file. For the most part,
              we're aligned with how your team has scoped this.
            </p>
            <p>
              WideOrbit stays as it is, Goals gets replaced with a Monthly Budget object,
              and deal line items get broken into monthly forecast records using custom
              code.
            </p>
            <p>
              The one thing we'd add is a nightly roll-up. HubSpot doesn't handle comparing
              three unrelated objects well in reporting, so we'd write booked and forecast
              numbers onto each budget record. Every pacing report then pulls from one
              place. It's not a big piece of work, but it's what makes the dashboards
              actually usable.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="bg-white border border-hair rounded-md p-5" data-testid="four-numbers">
            <h3 className="font-display text-lg text-coal">The four numbers every view answers</h3>
            <table className="mt-4 w-full text-[14px]" data-testid="four-numbers-table">
              <tbody>
                {FOUR.map(([k, v]) => (
                  <tr key={k} className="border-b border-hair last:border-0">
                    <td className="py-2.5 pr-4 font-medium text-coal align-top whitespace-nowrap">{k}</td>
                    <td className="py-2.5 text-fog leading-relaxed">{v}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="mt-4 text-[12.5px] text-fog leading-relaxed">
              Each one is available per AE, per market and for the company, by category
              group (Broadcast, Digital, Magazine) and the 8 pacing categories.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
